import React from 'react';
import classNames from 'classnames';
import { Typography, TypographyColor } from '../../typography/typography';
import { useAccentBgContext } from '../../accent-bg-context/accent-bg-context';
import styles from './text-with-label.module.scss';

type Props = {
  children: string;
  label: string;
  labelPosition: 'front' | 'back';
};

export const TextWithLabel: React.FC<Props> = ({ children, label, labelPosition }) => {
  const { isAccentBackground } = useAccentBgContext();

  const labelInFront = labelPosition === 'front';
  let textColor: TypographyColor = 'black';
  if (isAccentBackground) textColor = 'white';

  const Label = (
    <Typography color={textColor} fontStyle="bold" variant="smalltext">
      {label}
    </Typography>
  );

  return (
    <span className={classNames(styles.root, { [styles.frontLabel]: labelInFront })}>
      {labelInFront ? Label : null}
      <Typography color={textColor} fontStyle="bold" variant="maintext">
        {children}
      </Typography>
      {!labelInFront ? Label : null}
    </span>
  );
};
